import {SidebarContributors as ContributorsComponent} from '@github-ui/code-view-sidebar/components/SidebarContributors'
import {isCombinedSidebarPayloadEnabled} from '@github-ui/code-view-sidebar/is-enabled'
import type {SidebarContributorsResponse} from '@github-ui/code-view-sidebar/types'
import {useCombinedSidebarPayload} from '@github-ui/code-view-sidebar/use-combined-sidebar-payload'
import {useSuspenseQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface Props {
  ownerLogin: string
  repoName: string
}

export function SidebarContributors(props: Props) {
  return isCombinedSidebarPayloadEnabled() ? (
    <SidebarContributorsCombined {...props} />
  ) : (
    <SidebarContributorsIndividual {...props} />
  )
}

function SidebarContributorsCombined({ownerLogin, repoName}: Props) {
  const {contributors} = useCombinedSidebarPayload(ownerLogin, repoName)
  if (!contributors) return null
  return <ContributorsComponent {...contributors} />
}

function SidebarContributorsIndividual({ownerLogin, repoName}: Props) {
  const {data} = useSuspenseQuery({
    queryKey: ['code-view-sidebar', 'contributors', {ownerLogin, repoName}],
    queryFn: async () => {
      const r = await verifiedFetchJSON(`/${ownerLogin}/${repoName}/_sidebar/contributors`)
      if (!r.ok) throw new Error(`Sidebar contributors fetch failed (${r.status})`)
      return (await r.json()) as SidebarContributorsResponse
    },
  })

  if (!data) return null
  return <ContributorsComponent {...data} />
}
